const config = {
    build_number: '617330',
    build_timestamp: '2026-10-20T15:48:31.037Z',
    build_commit: '8b0c663eeecba9989408d5fb8067d74b3b680d64',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
